import React from "react"
import types from "prop-types"
import clsx from "clsx"
import DataCollectorContainerHeader from "./DataCollectorContainerHeader"

const DataCollectorContainer = ({ children, renderHeaderContent = null, className = "mb-40" }) => (
  <div
    className={clsx("bg-white w-full rounded-lg border-2 border-light-300", className)}
    style={{ boxShadow: "0px 1px 1px #D6D8E4" }}
  >
    {
      renderHeaderContent && (
        <DataCollectorContainerHeader>
          {renderHeaderContent()}
        </DataCollectorContainerHeader>
      )
    }
    <div className="py-10 px-6">
      {children}
    </div>
  </div>
)

DataCollectorContainer.propTypes = {
  children: types.node.isRequired,
  renderHeaderContent: types.func,
  className: types.string,
}

export default DataCollectorContainer
